/*
 * @Author: your name
 * @Date: 2021-09-24 10:10:34
 * @LastEditTime: 2021-09-28 14:02:23
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/router/combinationCourse.js
 */
// 优惠券
const combinationCourse = () => import('@/pages/combinationCourse/combinationCourse.vue');
const branchSchoolCombinationCourse = () => import('@/pages/branchSchoolCombinationCourse/combinationCourse.vue');
export default [
  {
    path: '/combinationCourse',
    component: combinationCourse,
    name: 'combinationCourse',
    meta: {
      title: '课程套餐',
    },
  },
  {
    path: '/branchSchoolCombinationCourse',
    component: branchSchoolCombinationCourse,
    name: 'branchSchoolCombinationCourse',
    meta: {
      title: '课程套餐',
    },
  },
];
